import {Controller} from '@hotwired/stimulus';
import {get} from '@rails/request.js';

export default class extends Controller {
  static targets = [
    'stripeForm',
    'addNewPaymentContainer',
    'container',
    'stripeFormError'
  ];

  static values = {
    stripeKey: String,
    refreshPath: String,
  };

  addNewClicked(event) {
    event.preventDefault();

    // Check if there's a refreshed client secret from the event target
    const clientSecret = event.target.dataset.userPaymentsClientSecretValue;

    /* Show Stripe form and hide this button */

    window.stripeClient = Stripe(this.stripeKeyValue);
    window.elements = window.stripeClient.elements({clientSecret: clientSecret});

    const paymentElement = window.elements.create('payment');
    this.addNewPaymentContainerTarget.classList.remove('d-none');
    paymentElement.mount(this.stripeFormTarget);
  }

  /**
   * Handles the form submission for adding a new payment method
   * @param event
   */
  submit(event) {
    event.preventDefault();

    if (!window.stripeClient || !window.elements) {
      console.error('Stripe client or elements not initialized');
      return;
    }

    this.containerTarget.ariaBusy = true;

    window.stripeClient.confirmSetup({
      elements: window.elements,
      redirect: 'if_required',
    }).then((result) => {
      if (result.error) {
        throw new Error(result.error.message);
      } else {
        this.onAddPaymentSuccess(result.setupIntent);
      }
    }).catch((error) => {
      this.containerTarget.ariaBusy = false;
      this.stripeFormErrorTarget.textContent = error.message;
    });
  }

  /**
   * Hides the Stripe form and refreshes the payment list
   * @param result
   */
  async onAddPaymentSuccess(result) {
    this.stripeFormErrorTarget.textContent = '';

    if (window.elements) {
      window.elements.getElement('payment').unmount();
    }
    this.addNewPaymentContainerTarget.classList.add('d-none');

    /* Refresh the payment list */
    let url = this.refreshPathValue;
    /* Add new payment id to the path */
    if (result && result.payment_method) {
      const separator = url.includes('?') ? '&' : '?';
      url += `${separator}new_payment_method_id=${result.payment_method}`;
    }
    await get(url);
    this.containerTarget.ariaBusy = false;
  }
}
